import { useQuery } from '@tanstack/react-query';
import { MOAGROUP_COLLECTION } from 'constants/gcConstants';
import { G_MOA_GROUPS_QUERY_KEY } from 'constants/queryKeys';
import { GBase } from 'interfaces/IGlobalCatalogue';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

/** Mode of action groups, offered on an active constituent when adding a product. */
export const useFetchGMoaGroups = (enabled = true) => {
  return useQuery<GBase[]>({
    queryKey: [G_MOA_GROUPS_QUERY_KEY],
    queryFn: () =>
      GlobalCatalogueService.FetchGReferenceCollectionData(MOAGROUP_COLLECTION),
    staleTime: 1000 * 60 * 30,
    enabled,
  });
};
